import clsx from 'clsx'
import { Icon, Typography } from 'components'
import { HelperProps, Icons, TypographyTypes } from 'interfaces'
import React, { useState } from 'react'
import { usePopper } from 'react-popper'

export const HelperHover: React.FC<HelperProps> = ({
	text,
	className,
	classPanel,
	filpath = false
}): JSX.Element => {
	const [referenceElement, setReferenceElement] =
		useState<HTMLDivElement | null>(null)
	const [popperElement, setPopperElement] = useState<HTMLDivElement | null>(
		null
	)
	const [isOpen, setIsOpen] = useState(false)
	const { styles, attributes } = usePopper(referenceElement, popperElement, {
		placement: 'right-start'
	})

	return (
		<div className={className}>
			<div
				className="flex items-center cursor-pointer"
				ref={setReferenceElement}
				onMouseEnter={() => setIsOpen(true)}
				onMouseLeave={() => setIsOpen(false)}
				aria-label="helper hover"
			>
				<Icon
					src={Icons.help}
					fillPath={filpath}
					className="w-5 h-5 text-white"
				/>
			</div>
			{isOpen && (
				<div
					className={clsx(
						'absolute !top-[4px] z-10 bg-gray-3 px-4 py-2 min-w-[300px] rounded-2xl',
						classPanel
					)}
					ref={setPopperElement}
					style={styles.popper}
					{...attributes.popper}
					onMouseEnter={() => setIsOpen(true)}
					onMouseLeave={() => setIsOpen(false)}
				>
					<Typography
						type={TypographyTypes.span}
						fontLeading="15/18"
						title={text}
						className="text-white !font-bold"
					/>
				</div>
			)}
		</div>
	)
}
